export const ADD_TO_JOB_PROFILE_LIMIT = 500;

export interface AddToJobStageOption {
  id: string;
  name: string;
  position: number;
  is_system: boolean;
}

export interface AddToJobJobOption {
  id: string;
  title: string;
  stages: AddToJobStageOption[];
}

export interface AddToJobSelection {
  jobId: string | null;
  stageId: string | null;
}

export function getAddToJobLimitError(count: number): string | null {
  if (count <= ADD_TO_JOB_PROFILE_LIMIT) return null;

  const overflow = count - ADD_TO_JOB_PROFILE_LIMIT;
  return `You can add up to ${ADD_TO_JOB_PROFILE_LIMIT} profiles to a job at a time. Reduce your selection by ${overflow} and try again.`;
}

export function sortAddToJobStages(
  stages: AddToJobStageOption[],
): AddToJobStageOption[] {
  return [...stages].sort((a, b) => a.position - b.position);
}

export function getDefaultAddToJobStageId(
  job: AddToJobJobOption | null | undefined,
): string | null {
  if (!job) {
    return null;
  }

  return sortAddToJobStages(job.stages)[0]?.id ?? null;
}

export function buildAddToJobSelection(
  jobs: AddToJobJobOption[],
  preferredJobId?: string | null,
): AddToJobSelection {
  const selectedJob = preferredJobId
    ? (jobs.find((job) => job.id === preferredJobId) ?? null)
    : null;

  return {
    jobId: selectedJob?.id ?? null,
    stageId: getDefaultAddToJobStageId(selectedJob),
  };
}
